import { render, staticRenderFns } from "./PostComment.vue?vue&type=template&id=5d6b2bc0&scoped=true&"
import script from "./PostComment.vue?vue&type=script&lang=js&"
export * from "./PostComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b2bc0",
  null
  
)

export default component.exports